module.exports = __webpack_public_path__ + "img/1f967.4b41762.svg";